module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_4-f65d6e40ea5f7ed47ed23c58f689ad35.jpg";